(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1141],{

/***/ 49478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Node"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LineNode"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sensor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NodeSensor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Sensor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"peripheralId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"config"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SensorConfig"},"directives":[]}]}}]}}],"loc":{"start":0,"end":329}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/sensor-config.gql\'\\n\\nfragment Node on LineNode {\\n  id\\n  type\\n  peripheralId\\n  sensor {\\n    _id\\n    peripheralId\\n    name\\n    description\\n    config {\\n      ...SensorConfig\\n    }\\n  }\\n}\\n\\nfragment NodeSensor on Sensor {\\n  _id\\n  id\\n  peripheralId\\n  name\\n  description\\n  config {\\n    ...SensorConfig\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(71449).definitions)));


      module.exports = doc;
    


/***/ }),

/***/ 30182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ line_list_topology; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/ArrowForward.js
var ArrowForward = __webpack_require__(26106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(16066);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(66038);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Accordion/Accordion.js
var Accordion = __webpack_require__(74110);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(33804);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(67815);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Chip/Chip.js + 1 modules
var Chip = __webpack_require__(18335);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(66637);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(8942);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(85000);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(96620);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Autocomplete/Autocomplete.js
var Autocomplete = __webpack_require__(43964);
// EXTERNAL MODULE: ./helpers/input.tsx
var input = __webpack_require__(23415);
;// CONCATENATED MODULE: ./views/dialogs/line-settings/setup-line/add-scrap-sensor.tsx












var AddScapSensor = function(props) {
    var availableNodes = props.availableNodes, setupNodes = props.setupNodes, title = props.title, onAddScrapSensor = props.onAddScrapSensor, onRemoveScrapSensor = props.onRemoveScrapSensor;
    var ref = (0,react.useState)([]), searchValues = ref[0], setSearchValues = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref1[0];
    (0,react.useEffect)(function() {
        var newSearchValues = setupNodes.map(function(node) {
            return {
                id: node.peripheralId,
                label: node.sensorName
            };
        });
        setSearchValues(newSearchValues);
    }, [
        setupNodes
    ]);
    var onAutocompleteChange = function(value) {
        var previousSensors = searchValues.filter(function(s) {
            return (0,input/* isSearchValueType */.o)(s);
        }).map(function(s) {
            return s;
        });
        var newSensors = value.filter(function(s) {
            return (0,input/* isSearchValueType */.o)(s);
        }).map(function(s) {
            return s;
        });
        if (previousSensors.length < newSensors.length) {
            var addedSensors = newSensors.filter(function(s) {
                return !previousSensors.some(function(node) {
                    return node.id === s.id;
                });
            });
            addedSensors.forEach(function(s) {
                return onAddScrapSensor(s.id);
            });
        }
        if (newSensors.length < previousSensors.length) {
            var removedSensors = previousSensors.filter(function(prevSensor) {
                return !newSensors.some(function(newSensor) {
                    return prevSensor.id === newSensor.id;
                });
            });
            removedSensors.forEach(function(s) {
                return onRemoveScrapSensor(s.id);
            });
        }
        setSearchValues(value);
    };
    var renderAutocomplete = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
            filterSelectedOptions: true,
            disableCloseOnSelect: true,
            isOptionEqualToValue: function(option, value) {
                return (0,input/* isSearchValueType */.o)(option) && (0,input/* isSearchValueType */.o)(value) ? option.id === value.id : option === value;
            },
            value: searchValues,
            onChange: function(event, value) {
                return onAutocompleteChange(value);
            },
            getOptionLabel: function(option) {
                return (0,input/* isSearchValueType */.o)(option) ? option.label : option;
            },
            multiple: true,
            id: "tags-standard",
            options: availableNodes.map(function(node) {
                return {
                    id: node.peripheralId,
                    label: node.sensorName
                };
            }),
            renderInput: function(params) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    fullWidth: true,
                    variant: "filled",
                    label: t("line:selectSensor", "Select sensor")
                }));
            },
            noOptionsText: t("line:noAvailableSensors", "No available sensors. Please add counters to the line")
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
        elevation: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                children: renderAutocomplete()
            })
        ]
    });
};
/* harmony default export */ var add_scrap_sensor = (AddScapSensor);

;// CONCATENATED MODULE: ./views/dialogs/line-settings/setup-line/line-list-topology.tsx

















var useStyles = (0,mui/* makeStyles */.ZL)()(function() {
    return {
        container: {
            alignItems: "center"
        },
        scrapContainer: {
            marginTop: "20px",
            marginBottom: "20px"
        },
        item: {
            alignSelf: "center",
            justifySelf: "center",
            display: "flex"
        },
        centered: {
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "auto",
            marginBottom: "auto"
        }
    };
});
var LineListTopology = function(props) {
    var mainSensorNodePeripheralId = props.mainSensorNodePeripheralId, mainSensorNodeName = props.mainSensorNodeName, availableNodes = props.availableNodes, nodeLinks = props.nodeLinks, onAddScrapSensor = props.onAddScrapSensor, onRemoveScrapSensor = props.onRemoveScrapSensor;
    var classes = useStyles().classes;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var nodesBeforeMain = availableNodes.filter(function(node) {
        return nodeLinks.some(function(link) {
            return link.source === node.peripheralId && link.target === mainSensorNodePeripheralId;
        });
    });
    var nodesAfterMain = availableNodes.filter(function(node) {
        return nodeLinks.some(function(link) {
            return link.source === mainSensorNodePeripheralId && link.target === node.peripheralId;
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {}),
                "aria-controls": "panel1a-content",
                id: "panel1a-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle1",
                        children: t("line:setupScrapSensors", "Specify scrap sensor placement")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        title: t("line:setupScrapSensorsInfo", "To correctly calculate the number of items produced, please indicate the placement of all scrap sensors on the line"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                fontSize: "small"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    className: classes.container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            className: classes.scrapContainer,
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_scrap_sensor, {
                                title: t("line:priorToBottleneck", "Scrap sensors prior to bottleneck"),
                                availableNodes: availableNodes.filter(function(n) {
                                    return !nodesAfterMain.some(function(n2) {
                                        return n2.peripheralId === n.peripheralId;
                                    });
                                }),
                                setupNodes: nodesBeforeMain,
                                onAddScrapSensor: function(sensorId) {
                                    return onAddScrapSensor(sensorId, true);
                                },
                                onRemoveScrapSensor: function(sensorId) {
                                    return onRemoveScrapSensor(sensorId);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            className: classes.item,
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* default */.Z, {
                                mdDown: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        className: classes.centered
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                                        size: "medium",
                                        label: "".concat(mainSensorNodeName, " (").concat(t("line:bottleneckSensor", "bottleneckSensor"), ")")
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        className: classes.centered
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            className: classes.scrapContainer,
                            item: true,
                            xs: 12,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(add_scrap_sensor, {
                                title: t("line:afterBottleneck", "Scrap sensors after bottleneck"),
                                availableNodes: availableNodes.filter(function(n) {
                                    return !nodesBeforeMain.some(function(n2) {
                                        return n2.peripheralId === n.peripheralId;
                                    });
                                }),
                                setupNodes: nodesAfterMain,
                                onAddScrapSensor: function(sensorId) {
                                    return onAddScrapSensor(sensorId, false);
                                },
                                onRemoveScrapSensor: function(sensorId) {
                                    return onRemoveScrapSensor(sensorId);
                                }
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var line_list_topology = (LineListTopology);


/***/ }),

/***/ 3911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30985);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24267);
/* harmony import */ var _mui_material_Chip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18335);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8942);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);








var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        sensorCard: {
            maxHeight: "180px",
            overflowY: "scroll",
            margin: "10px"
        },
        sensorChip: {
            marginRight: theme.spacing(0.5),
            marginBottom: theme.spacing(1)
        },
        unselected: {
            color: "black"
        },
        selected: {
            color: "white"
        }
    };
});
var SelectSensor = function(props) {
    var title = props.title, sensors = props.sensors, selectedSensorIds = props.selectedSensorIds, onSelectSensor = props.onSelectSensor, disabledSensorId = props.disabledSensorId;
    var classes = useStyles().classes;
    var sortedSensors = sensors.sort(function(l, r) {
        return l.name.localeCompare(r.name);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        elevation: 3,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    variant: "subtitle1",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.sensorCard,
                    children: sortedSensors.map(function(sensor) {
                        var sensorSelected = selectedSensorIds.some(function(sensorId) {
                            return sensorId === sensor.peripheralId && sensorId !== disabledSensorId;
                        });
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            placement: "top",
                            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                        children: sensor.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    sensor.description
                                ]
                            }),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Chip__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                label: sensor.name,
                                onClick: function() {
                                    return onSelectSensor(sensor);
                                },
                                className: "".concat(sensorSelected ? classes.selected : classes.unselected, " ").concat(classes.sensorChip),
                                variant: sensorSelected ? "filled" : "outlined",
                                color: "primary",
                                disabled: sensor.peripheralId === disabledSensorId
                            }, "".concat(sensor.name, "-").concat(sensor.peripheralId, "-chip"))
                        }, "".concat(sensor.name, "-").concat(sensor.peripheralId, "-tooltip"));
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectSensor);


/***/ }),

/***/ 17649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30985);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24267);
/* harmony import */ var _mui_material_TextField__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96620);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52875);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82672);
/* harmony import */ var tss_react_mui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99109);










var useStyles = (0,tss_react_mui__WEBPACK_IMPORTED_MODULE_2__/* .makeStyles */ .ZL)()(function(theme) {
    return {
        textFields: {
            marginLeft: theme.spacing(),
            marginRight: theme.spacing(),
            marginTop: "20px"
        }
    };
});
var SpecifyLineInfo = function(param) {
    var lineInfo = param.lineInfo, onChangeLineInfo = param.onChangeLineInfo;
    var classes = useStyles().classes;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)(), 1), t = ref[0];
    var updateLineInfo = function(field) {
        return function(e) {
            var newLineInfo = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, lineInfo);
            newLineInfo[field] = e.target.value;
            onChangeLineInfo(newLineInfo);
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        elevation: 3,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    align: "center",
                    variant: "subtitle1",
                    children: t([
                        "line:lineSettings"
                    ], {
                        defaultValue: "Line Settings"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    variant: "filled",
                    id: "select-line-name",
                    value: lineInfo.name,
                    className: classes.textFields,
                    type: "text",
                    required: true,
                    error: lineInfo.name.length === 0,
                    fullWidth: true,
                    onChange: updateLineInfo("name"),
                    label: t([
                        "line:lineName"
                    ], {
                        defaultValue: "Line name"
                    })
                }, "select-line-name"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_TextField__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    variant: "filled",
                    id: "select-line-description",
                    value: lineInfo.description,
                    className: classes.textFields,
                    type: "text",
                    fullWidth: true,
                    onChange: updateLineInfo("description"),
                    label: t([
                        "line:lineDescription"
                    ], {
                        defaultValue: "Line description"
                    })
                }, "select-line-description")
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SpecifyLineInfo);


/***/ })

}]);